<template>
  <v-alert color="indigo-faint" class="text-primary py-0 px-1" height="32px" density="compact">
    <div class="body2 d-flex align-center">
      <v-icon icon="$protectionXs" size="24" class="mr-1" />
      <div class="mr-1">
        {{
          $t(
            "ticketDetails.notProtectedUsersNotice",
            { n: ticketDetails.potentiallyProtectableUsers.length },
            ticketDetails.potentiallyProtectableUsers.length
          )
        }}
      </div>
      <div
        class="coro-link body2"
        :class="{ 'text-indigo-medium cursor-default': addUsersNotAllowed }"
        @click="handleAddUsersClick"
        data-testid="tickets-page-add-users-btn"
      >
        {{ $t("ticketDetails.addProtectionBtn") }}
      </div>
    </div>
  </v-alert>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import type { TicketDetails } from "@/_store/tickets/tickets.module";

export default defineComponent({
  props: {
    ticketDetails: {
      type: Object as PropType<TicketDetails>,
      required: true,
    },
    addUsersNotAllowed: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["on-users-add-clicked"],
  setup(_, { emit }) {
    const handleAddUsersClick = () => {
      emit("on-users-add-clicked");
    };

    return {
      handleAddUsersClick,
    };
  },
});
</script>
